import { render, staticRenderFns } from "./RichMenuPreview.vue?vue&type=template&id=67f496af&scoped=true&"
import script from "./RichMenuPreview.vue?vue&type=script&lang=js&"
export * from "./RichMenuPreview.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuPreview.vue?vue&type=style&index=0&id=67f496af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f496af",
  null
  
)

export default component.exports